"use client";

import React, { useEffect, useState } from "react";
import { FormHeading, SuccessMessageType } from "@/interface/types";
import Image from "next/image";
import { getFormOneDataFromLocal } from "@/lib/edcrypt";
import EnqueryForm from "../forms/EnqueryForm";

const LOCAL_STORE_NAME = "MILES_NEXT_F1_REF_ENQUIRY";

const QuickContact: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [, setHasUserClosedSidebar] = useState(false);
  const [isFormFilled, setIsFormFilled] = useState<boolean>(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    setHasUserClosedSidebar(!isSidebarOpen);
  };

  useEffect(() => {
    const isMobile = window.innerWidth <= 768;

    if (isSidebarOpen && isMobile) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isSidebarOpen]);
  useEffect(() => {
    const { status } = getFormOneDataFromLocal(LOCAL_STORE_NAME);
    setIsFormFilled(status);
  }, []);

  if (isFormFilled) {
    return null;
  }

  return (
    <div className="relative block z-[99px]">
      {!isSidebarOpen && (
        <button
          className="fixed fixed_btn font-semibold"
          onClick={toggleSidebar}
        >
          {isSidebarOpen ? "X" : "Get in Touch"}
        </button>
      )}
      <div
        className={`fixed md:top-[18%] top-[20%] z-[99] -right-2 md:w-[370px] w-[320px] py-6 px-0 pb-0 transform transition-transform duration-700 ease-in ${
          isSidebarOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div
          className="rounded-2xl p-4 bg-[#263546]"
          style={{
            boxShadow: "0px 0px 14px 0px rgba(4, 84, 175, 0.29)",
            backdropFilter: "blur(28px)",
          }}
        >
          <button
            onClick={toggleSidebar}
            className="md:text-2xl text-xl absolute md:top-2 md:right-2 top-1 right-1 text-white cursor-pointer"
            title="Close"
            aria-label="Apply-Now-Button"
            name="Apply-Now-Button"
          >
            ✕
          </button>
          <div>
            <Image
              src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit/starGroup.webp"
              alt="star group"
              width={34}
              height={38}
              className="absolute top-3 left-[-8px]"
            />
            <EnqueryForm
              course="CPA"
              courseId={1}
              formType="quickConnect"
              submitButtonName="Get In Touch"
              successMessage={SuccessMessageType.QUICK_CONNECT}
              darkBackground={true}
              isAStepperForm
              formHeading={FormHeading.QUICK_CONNECT}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickContact;
